import React from "react";
import { useSelector } from "react-redux";
import { useFirestoreConnect } from "react-redux-firebase";
import spots from "../../config/spots";
import AppContainer from "../../components/AppContainer";
import Header from "../../components/Header";
import PageTitle from "../../components/PageTitle";
import BuoySummary from "./BuoySummary";
import HomeSpotsContainer from "./HomeSpotsContainer";
import NavBar from "../../components/NavBar/index";

const Home = () => {
  useFirestoreConnect([
    {
      collection: "buoys",
    },
  ]);
  const buoys = useSelector(({ firestore: { data } }) => data.buoys);
  return (
    <AppContainer>
      <Header home>
        <PageTitle>
          Waves
          <br />
          Near
          <br />
          Me
        </PageTitle>
      </Header>
      <HomeSpotsContainer>
        {/* {console.log("buoys", buoys && buoys.cadiz.buoyData)} */}
        {buoys &&
          spots.map((spot, index) => {
            if (buoys[spot] && buoys[spot].buoyData[0]) {
              const spotData = buoys[spot].buoyData;
              const { date, peakPeriod, height } = spotData[0];
              const previous = spotData[1];
              let change = "no-change";
              if (height > previous.height) {
                change = "increase";
              }
              if (height < previous.height) {
                change = "decrease";
              }
              return (
                <React.Fragment key={index}>
                  <BuoySummary
                    spotName={spot}
                    date={date}
                    height={height}
                    peakPeriod={peakPeriod}
                    change={change}
                  />
                </React.Fragment>
              );
            }
            return (
              <React.Fragment key={index}>
                <BuoySummary spotName={spot} />
              </React.Fragment>
            );
          })}
      </HomeSpotsContainer>
      <NavBar home />
    </AppContainer>
  );
};

export default Home;
